import React from "react";
import styled from "styled-components";
import lena from "../../assets/portraits/p-lena.png";
import sofie from "../../assets/portraits/p-sofie.png";
import andrea from "../../assets/portraits/p-andrea.png";
import johanna from "../../assets/portraits/p-johanna.png";
import benke from "../../assets/portraits/p-benke.png";
import doris from "../../assets/portraits/p-doris.png";


export const OmOssContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 140px 0;
  padding: 0 20px;
`;

export const TeamImg = styled.img`
  max-width: 310px;
  height: auto;
  margin: 20px 0;

  @media screen and (min-width: 768px) {
    max-width: 550px;
    margin: 30px 0;
  }

  @media screen and (min-width: 1024px) {
    max-width: 750px;
    margin: 40px 0;
  }
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, auto);
  column-gap: 22px;
  row-gap: 0px;
  justify-items: center;
  align-items: center;
  max-width: 800px;
  max-height: 480px;
  overflow: hidden;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    transform: scale(0.85);
    column-gap: 22px;
    row-gap: 0px;
    overflow: hidden;
    height: 320px;
  }

  @media (max-width: 480px) {
    transform: scale(0.8);
    transform-origin: top center;
    column-gap: 15px;
    row-gap: 13px;
    max-width: 350px;
    padding: 10px 0;
    margin: 0;
    overflow: hidden;
    height: 265px;
  }
`;

const ImgJohanna = styled.img`
  grid-column: 1;
  grid-row: 1;
  transform: translateY(40px);
  width: 150px;

  @media (max-width: 768px) {
    width: 100px;
  }
  @media (max-width: 480px) {
    width: 80px;
  }
`;

const ImgLena = styled.img`
  grid-column: 3;
  grid-row: 1;
  transform: translateY(30px) translateX(-40px);
  width: 140px;

@media (max-width: 768px) {
  width: 100px;
}
@media (max-width: 480px) {
  width: 80px;
}
`;

const ImgSofie = styled.img`
  grid-column: 2;
  grid-row: 2;
  transform: translateY(-20px);
  width: 160px;

@media (max-width: 768px) {
  width: 110px;
}
@media (max-width: 480px) {
  width: 80px;
}
`;

const ImgAndrea = styled.img`
  grid-column: 4;
  grid-row: 2;
  width: 130px;
  transform: translateY(-70px) translateX(-30px);

@media (max-width: 768px) {
  width: 90px;
}
@media (max-width: 480px) {
  width: 80px;
}
`;

const ImgBenke = styled.img`
  grid-column: 1;
  grid-row: 3;
  width: 130px;
  transform: translateY(-180px);

@media (max-width: 768px) {
  width: 90px;
  transform: translateY(-100px);
}
@media (max-width: 480px) {
  width: 75px;
  transform: translateY(-70px);
}
`;

const ImgDoris = styled.img`
  //grid-column: 3; take back after easter
  //grid-row: 3;
  width: 140px;
  transform: translateY(-150px);

@media (max-width: 768px) {
  width: 90px;
  transform: translateY(-100px);
}
@media (max-width: 480px) {
  width: 80px;
}
`;


const DorisWrapper = styled.div`
  position: relative;
  grid-column: 3;
  grid-row: 3;
`;

export const TeamGrid: React.FC = () => {

  return (
    <GridWrapper>
      <ImgJohanna src={johanna} alt="Johanna" />
      <ImgLena src={lena} alt="Lena" />
      <ImgSofie src={sofie} alt="Sofie" />
      <ImgAndrea src={andrea} alt="Andrea" />
      <ImgBenke src={benke} alt="Benke" />
      <DorisWrapper>
      <ImgDoris src={doris} alt="Doris" />
      </DorisWrapper>
    </GridWrapper>
  );
};
